import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../components/table';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import {setGetJackpotList} from '../../store/thunk/setGetJackpotList';
import {columns, getRows} from './helpers';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';
import {useFormik, FormikContext} from "formik";
import {setPostJackpotIssue} from '../../store/thunk/setPostJackpotIssue';
import { setPostNullify } from '../../store/thunk/setPostNullify';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    addJackpot: {
        padding: 10, 
        background: '#ffc324', 
        borderRadius: 4, 
        cursor: 'pointer', 
        color: '#141b33',
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    }
}))

const JackpotList = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const classes = useStyles();
    const [showModal, setShowModal] = React.useState(false);
    const [confirmModal, setConfirmModal] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetJackpotList());
    }, [])

    const list = useSelector(state => state.jackpot.list_jackpot);
    const rows = React.useMemo(() => getRows(list), [list]);

    const onSubmit = (store) => {
        if (store.type === 'give out') {
            dispatch(setPostJackpotIssue(store))
        } else if (store.type === 'nullify') {
            dispatch(setPostNullify(store))
        }
    }

    const initialValues = {
        group: '',
        jackpot: '',
        user: '',
        id: 0,
        type: '',
        bet: 0,
        game_uuid: ''
    }

    const enableReinitialize = true;
    const formik = useFormik({onSubmit, initialValues, enableReinitialize});

    return (
        <div className={classes.root}>
            <Title label="Список Джекпотов" />
            <div className={classes.wrapBlock}>
                <span className={classes.addJackpot}
                    
                    onClick={() => router.history.push('/jackpot/create')}
                >Добавить джекпот</span>
            </div>
            <div className={classes.wrapTable}>
                <TableCasino 
                    width={1600}
                    route='/jackpot/edit/'
                    columns={columns}
                    rows={rows}
                    setShowModal={setShowModal}
                    setConfirmModal={setConfirmModal}
                    setInitialValues={(v) => {
                        formik.setFieldValue('id', v.id);
                        formik.setFieldValue('group', v.group);
                        formik.setFieldValue('jackpot', v.jackpot);
                        formik.setFieldValue('type', v.type);
                    }}
                />
            </div>
            <Dialog onClose={() => setConfirmModal(false)} open={confirmModal}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit} className={classes.root} >
                        <div style={{width: 300, padding: 20, paddingBottom: 0, display: 'flex', flexDirection: 'column'}}>
                            <h3 style={{textAlign: 'center', padding: 0, margin: 0, color: '#2f2f2f'}}>Вы точно хотите обнулить джекпот?</h3>
                            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 12, width: '100%'}}>
                                <span 
                                    style={{padding: '10px 15px', background: '#ffc324', textAlign: 'center', borderRadius: 4, width: '39%', cursor: 'pointer'}}
                                    onClick={() => {
                                        setConfirmModal(false);
                                        formik.submitForm();
                                    }}
                                    >
                                    Обнулить
                                </span>
                                <span 
                                    style={{padding: '10px 15px', background: '#d4d3d2', textAlign: 'center', borderRadius: 4, width: '39%', cursor: 'pointer'}}
                                    onClick={() => {
                                        setConfirmModal(false);
                                    }}
                                    >
                                    Отмена
                                </span>
                            </div>
                        </div>
                    </form>
                </FormikContext.Provider>
            </Dialog>
            <Dialog onClose={() => setShowModal(false)} open={showModal}>
                <FormikContext.Provider value={formik}>
                    <form onSubmit={formik.handleSubmit} className={classes.root} >
                    <div style={{width: 300, padding: 20, display: 'flex', flexDirection: 'column'}}>
                        <h3 style={{textAlign: 'center', padding: 0, margin: 0, color: '#2f2f2f'}}>Выдать джекпот</h3>
                        <label htmlFor="group" style={{display: 'flex', flexDirection: 'column'}}>
                            <span style={{color: '#8599c7'}}>Группа</span>
                            <input 
                                type="text" 
                                disabled 
                                value={formik.values.group}
                                style={{
                                    border: '1px solid #8599c7',
                                    padding: 5
                                }}
                            />
                        </label>
                        <label htmlFor="jackpot" style={{display: 'flex', flexDirection: 'column'}}>
                            <span style={{color: '#8599c7'}}>Название джекпота</span>
                            <input 
                                type="text" 
                                disabled 
                                value={formik.values.jackpot}
                                style={{
                                    border: '1px solid #8599c7',
                                    padding: 5
                                }}
                            />
                        </label>
                        <label htmlFor="user" style={{display: 'flex', flexDirection: 'column', marginBottom: 12}}>
                            <span  style={{color: '#3d5a9c'}}>Логин игрока</span>
                            <input 
                                type="text" 
                                value={formik.values.user}
                                onChange={(v) => formik.setFieldValue('user', v.target.value)}
                                style={{
                                    border: '1px solid #3d5a9c',
                                    padding: 5,
                                    outline: 'none'
                                }}
                                />
                        </label>
                        <label htmlFor="user" style={{display: 'flex', flexDirection: 'column', marginBottom: 12}}>
                            <span  style={{color: '#3d5a9c'}}>Ставка</span>
                            <input 
                                type="text" 
                                value={formik.values.bet}
                                onChange={(v) => formik.setFieldValue('bet', v.target.value)}
                                style={{
                                    border: '1px solid #3d5a9c',
                                    padding: 5,
                                    outline: 'none'
                                }}
                                />
                        </label>
                        <label htmlFor="user" style={{display: 'flex', flexDirection: 'column', marginBottom: 12}}>
                            <span  style={{color: '#3d5a9c'}}>ID игры</span>
                            <input 
                                type="text" 
                                value={formik.values.game_uuid}
                                onChange={(v) => formik.setFieldValue('game_uuid', v.target.value)}
                                style={{
                                    border: '1px solid #3d5a9c',
                                    padding: 5,
                                    outline: 'none'
                                }}
                                />
                        </label>
                        <span 
                            style={{padding: '10px 15px', background: '#ffc324', textAlign: 'center', borderRadius: 4, cursor: 'pointer'}}
                            onClick={() => {
                                setShowModal(false)
                                formik.submitForm();
                            }}
                            >
                            Выдать
                        </span>
                    </div>
                    </form>
                </FormikContext.Provider>
            </Dialog>
        </div>
    )
}

export default JackpotList;